import _ from 'lodash';
import * as Backbone from "backbone";

import Menu from 'menu/Menu';
import {CollapsibleView} from "view/CollapsibleView";
import {FavFilterManageView} from "module/selpan/menu/FavFilterView";
import {FavOrderManageView} from "module/selpan/menu/FavOrderView";
import {FavStatusView} from "module/selpan/menu/FavStatusView";
import {FavRenameView} from "module/selpan/menu/FavRenameView";
import {FavSelectView} from "module/selpan/menu/FavSelectView";
import {AddView} from "module/selpan/menu/AddView";
import {SelPanResetSettingsView} from "module/selpan/menu/SelPanResetSettingsView";
import {SelPanMenuHeaderView} from "module/selpan/menu/SelPanMenuHeaderView";
import {FavCustomIncludeExcludeView} from "module/selpan/menu/FavCustomIncludeExcludeView";
import {FavCustomManualOrderView} from "module/selpan/menu/FavCustomManualOrderView";

export const SelPanMenuView = Backbone.View.extend({
	className: 'SelPanMenuView unselectableText',
	initialize: function (options) {
		this.fav = options.fav;
		this.selpan = options.selpan;
		let opts = {selpan: this.selpan, fav: this.fav};
		this.statusView = new FavStatusView(_.assign({}, opts, {showActivateButton: false}));
		this.ddMenu = this.generateDropDownMenu(opts);
		this.listenTo(this.ddMenu, "close", this.selpan.saveAllFav);
		this.listenTo(this.selpan.status, "change:favKey", this.showHideEditRegion);
		this.showHideEditRegion();
		this.render();
	},
	isFavFunctionActive(funcNames) {
		return _.some(funcNames, fn => {
			switch (fn) {
				case 'filters':
					return this.fav.filters.length;
				case 'orders':
					return this.fav.orders.length;
				case 'include':
					return _.get(this.fav.custom.get('include'), 'attributes.value.length');
				case 'exclude':
					return _.get(this.fav.custom.get('exclude'), 'attributes.value.length');
				case 'index':
					return _.get(this.fav.custom.get('index'), 'attributes.value.length');
				default:
					console.warn('unknown fav function type');
					return true;
			}
		})
	},
	generateDropDownMenu: function (opts) {
		let ext = {
			others: _.map(this.extViewClasses && this.extViewClasses.others, V => new V(opts))
		};
		let favSelectRegion = [
			new FavStatusView(_.assign({}, opts, {showActivateButton: true})),
			new FavSelectView(opts),
			new AddView({
				callback: _.bind(opts.selpan.generateNewFav, opts.selpan),
				label: 'Neuer Favorit'
			})
		];
		let favEditRegion = this.editRegion = [
			new Backbone.View({tagName: 'hr'}),
			new CollapsibleView({
				name: 'SelPanView2_FavEdit_' + this.selpan.collection.favEntity,
				collapsed: true,
				collapsedHeight: 26,
				views:
					[
						new SelPanMenuHeaderView(_.assign({}, opts, {
							label: 'Favoritengruppe bearbeiten',
							icon: 'fa',
							hint: 'Filter, Sortierung und Name für aktuellen Favoriten bearbeiten.',
							isAnyActive: () => this.isFavFunctionActive(['filters', 'orders', 'include', 'exclude', 'index'])
						})),
						new CollapsibleView({
							name: 'SelPanView2_FavFilter_' + this.selpan.collection.favEntity,
							collapsed: true,
							collapsedHeight: 26,
							views: [
								new SelPanMenuHeaderView(_.assign({}, opts, {
									label: 'Filter',
									icon: 'fa-filter',
									hint: 'Filter für aktuellen Favoriten bearbeiten. Filter definieren die auswählbaren Einträge in der Seitenleiste.',
									isAnyActive: () => this.isFavFunctionActive(['filters', 'include', 'exclude'])
								})),
								new FavCustomIncludeExcludeView(opts),
								new CollapsibleView({
									name: 'SelPanView2_FavFilter_field_' + this.selpan.collection.favEntity,
									collapsed: true,
									collapsedHeight: 26,
									views: [
										new SelPanMenuHeaderView(_.assign({}, opts, {
											label: 'Feldfilter',
											icon: 'fa-filter',
											hint: 'Feldfilter sind Suchbegriffe, die auf Felder zutreffen müssen, damit sie in der Liste aufscheinen. Sterne (*) sind Wildcards.',
											isAnyActive: () => this.isFavFunctionActive(['filters'])
										})),
										new FavFilterManageView(_.assign({}, opts, {collection: opts.fav.filters})),
										new AddView({
											className: '',
											callback: function () {
												opts.fav.filters.add({
													filterType: 'field',
													nr: opts.fav.filters.getNextNr({filterType: 'field'})
												});
											},
											label: 'Hinzufügen'
										})]
								}),
							]
						}),
						new Backbone.View({tagName: 'hr', className: 'SmallHR'}),
						new CollapsibleView({
							name: 'SelPanView2_FavOrder_' + this.selpan.collection.favEntity,
							collapsed: true,
							collapsedHeight: 26,
							views: [
								new SelPanMenuHeaderView(_.assign({}, opts, {
									label: 'Sortierung',
									icon: 'fa-sort',
									hint: 'Sortierung für aktuellen Favoriten bearbeiten',
									isAnyActive: () => this.isFavFunctionActive(['orders', 'index'])
								})),
								new FavCustomManualOrderView(opts),
								new CollapsibleView({
									name: 'SelPanView2_FavOrder_field_' + this.selpan.collection.favEntity,
									collapsed: true,
									collapsedHeight: 26,
									views: [
										new SelPanMenuHeaderView(_.assign({}, opts, {
											label: 'Feldsortierung',
											icon: 'fa-sort-alpha-asc',
											hint: 'Sortierung für aktuellen Favoriten bearbeiten',
											isAnyActive: () => this.isFavFunctionActive(['orders'])
										})),
										new FavOrderManageView(_.assign({}, opts, {collection: opts.fav.orders})),
										new AddView({
											className: '',
											callback: function () {
												opts.fav.orders.add({
													orderType: 'field',
													nr: opts.fav.orders.getNextNr({orderType: 'field'})
												});
											},
											label: 'Hinzufügen'
										})]
								})]
						}),
						new Backbone.View({tagName: 'hr', className: 'SmallHR'}),
						new FavRenameView(opts)
					]
			})
		];

		let globalRegion = [
			new Backbone.View({tagName: 'hr'}),
			new CollapsibleView({
				name: 'SelPanView2_FavSettings_' + this.selpan.collection.favEntity,
				collapsed: true,
				collapsedHeight: 26,
				views: [
					new SelPanMenuHeaderView(_.assign({}, opts, {
						label: 'Weitere',
						icon: 'fa-ellipsis-h',
						title: 'Globale Einstellungen: Die folgenden Menüpunkte wirken sich unabhängig von der aktuellen Favoritengruppe aus.',
						isAnyActive: () => false //() => this.isFavFunctionActive(['TODO'])
					})),
				]
					.concat(ext.others)
					.concat(new SelPanResetSettingsView(opts))
			})
		];
		let views = favSelectRegion.concat(favEditRegion).concat(globalRegion);
		this.selpan.collapsibleViews = _.filter(views, v => v instanceof CollapsibleView);
		return new Menu.DropDownView({
			$button: this.$el,
			closeAfterSelection: false,
			positionOptions: {
				init: 'over',
				position: 'fixed'
			},
			buttonEventNames: 'click',
			views: views
		});
	},
	showHideEditRegion: function () {
		let status = !!this.selpan.status.get('favKey');
		_.each(this.editRegion, function (v) {
			v.$el.toggle(status);
		});
	},
	render: function () {
		this.$el.html(this.statusView.el);
	}
});